import { useState } from "react";
import { Button } from "devextreme-react/button";
import AttachmentPopup from "./AttachmentPopup";
import { AttachmentProps } from "./types";
import Icon from '../icon';

const AttachmentFab: React.FC<AttachmentProps> = ({ docId, docType }) => {
    const [visible, setVisible] = useState<boolean>(false);

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    bottom: 30,
                    right: 30,
                    zIndex: 1000
                }}
            >
                <div
                    onClick={() => setVisible(true)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "12px 18px",
                        backgroundColor: "#ff6f00",
                        color: "white",
                        borderRadius: 50,
                        cursor: "pointer",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                        transition: "0.3s",
                        fontWeight: 500,
                        fontSize: 14
                    }}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "translateY(-3px)")
                    }
                    onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                    }
                >
                    <Icon icon="mdi:paperclip" />
                    <span>Attachments</span>
                </div>
            </div>

            <AttachmentPopup
                visible={visible}
                onClose={() => setVisible(false)}
                docId={docId}
                docType={docType}
            />
        </>
    );
};

export default AttachmentFab;
